/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  EndPrivateVehicleUsageRequestDto,
  EndVehicleUsageRequestDto,
  GetVehicleUsagesForVehicleParams,
  OverdueVehicleUsageDto,
  StartVehicleUsageRequestDto,
  VehicleUsageDto,
  VehicleUsagePageDto
} from '../../models';

import { customInstance } from '../../../../custom-instance';
import type { ErrorType , BodyType } from '../../../../custom-instance';




/**
 * Returns every vehicle usage that is currently active (started but not ended) across the whole fleet — both booking-linked usages and private/owner-driven usages. Each item is enriched with full reference objects: a vehicle reference (name, license plate, images, model), a user reference (the driver), and — for booking-linked usages — a booking reference (user, client, vehicle, status, periods). Private/owner-driven usages carry a booking reference too — it describes their system-generated mirror booking (bookingType SYNTHETIC). The references are resolved by fan-out to the booking domain (model info, fleet vehicles, active bookings, and per-driver lookups for private usages). The response is not paged: all active usages are returned in one call and totalElements always equals the number of items. The result size is bounded by the fleet size (at most one active usage per vehicle).
 * @summary Get all active vehicle usages
 */
export const getActiveVehicleUsages = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<VehicleUsagePageDto>(
      {url: `/fleet/active-usage/v1`, method: 'GET', signal
    },
      );
    }
  

export const getGetActiveVehicleUsagesQueryKey = () => {
    return [`/fleet/active-usage/v1`] as const;
    }

    
export const getGetActiveVehicleUsagesQueryOptions = <TData = Awaited<ReturnType<typeof getActiveVehicleUsages>>, TError = ErrorType<VehicleUsagePageDto | VehicleUsagePageDto | VehicleUsagePageDto>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveVehicleUsages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActiveVehicleUsagesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveVehicleUsages>>> = ({ signal }) => getActiveVehicleUsages(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActiveVehicleUsages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActiveVehicleUsagesQueryResult = NonNullable<Awaited<ReturnType<typeof getActiveVehicleUsages>>>
export type GetActiveVehicleUsagesQueryError = ErrorType<VehicleUsagePageDto | VehicleUsagePageDto | VehicleUsagePageDto>


export function useGetActiveVehicleUsages<TData = Awaited<ReturnType<typeof getActiveVehicleUsages>>, TError = ErrorType<VehicleUsagePageDto | VehicleUsagePageDto | VehicleUsagePageDto>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveVehicleUsages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveVehicleUsages>>,
          TError,
          Awaited<ReturnType<typeof getActiveVehicleUsages>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActiveVehicleUsages<TData = Awaited<ReturnType<typeof getActiveVehicleUsages>>, TError = ErrorType<VehicleUsagePageDto | VehicleUsagePageDto | VehicleUsagePageDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveVehicleUsages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveVehicleUsages>>,
          TError,
          Awaited<ReturnType<typeof getActiveVehicleUsages>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActiveVehicleUsages<TData = Awaited<ReturnType<typeof getActiveVehicleUsages>>, TError = ErrorType<VehicleUsagePageDto | VehicleUsagePageDto | VehicleUsagePageDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveVehicleUsages>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all active vehicle usages
 */

export function useGetActiveVehicleUsages<TData = Awaited<ReturnType<typeof getActiveVehicleUsages>>, TError = ErrorType<VehicleUsagePageDto | VehicleUsagePageDto | VehicleUsagePageDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveVehicleUsages>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActiveVehicleUsagesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns the currently active usage on the given vehicle, or null if there is none. The usage is enriched with full reference objects: a vehicle reference (name, license plate, images, model), a user reference (the driver), and — for a booking-linked usage — a booking reference (user, client, vehicle, status, periods). The booking reference is null for a private/owner-driven usage.
 * @summary Get the active vehicle usage for a single vehicle
 */
export const getActiveUsageForVehicle = (
    vehicleId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<VehicleUsageDto>(
      {url: `/fleet/active-usage/v1/vehicle/${vehicleId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetActiveUsageForVehicleQueryKey = (vehicleId?: string,) => {
    return [`/fleet/active-usage/v1/vehicle/${vehicleId}`] as const;
    }

    
export const getGetActiveUsageForVehicleQueryOptions = <TData = Awaited<ReturnType<typeof getActiveUsageForVehicle>>, TError = ErrorType<VehicleUsageDto | VehicleUsageDto | VehicleUsageDto>>(vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveUsageForVehicle>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActiveUsageForVehicleQueryKey(vehicleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveUsageForVehicle>>> = ({ signal }) => getActiveUsageForVehicle(vehicleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(vehicleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActiveUsageForVehicle>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActiveUsageForVehicleQueryResult = NonNullable<Awaited<ReturnType<typeof getActiveUsageForVehicle>>>
export type GetActiveUsageForVehicleQueryError = ErrorType<VehicleUsageDto | VehicleUsageDto | VehicleUsageDto>


export function useGetActiveUsageForVehicle<TData = Awaited<ReturnType<typeof getActiveUsageForVehicle>>, TError = ErrorType<VehicleUsageDto | VehicleUsageDto | VehicleUsageDto>>(
 vehicleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveUsageForVehicle>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveUsageForVehicle>>,
          TError,
          Awaited<ReturnType<typeof getActiveUsageForVehicle>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActiveUsageForVehicle<TData = Awaited<ReturnType<typeof getActiveUsageForVehicle>>, TError = ErrorType<VehicleUsageDto | VehicleUsageDto | VehicleUsageDto>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveUsageForVehicle>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveUsageForVehicle>>,
          TError,
          Awaited<ReturnType<typeof getActiveUsageForVehicle>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActiveUsageForVehicle<TData = Awaited<ReturnType<typeof getActiveUsageForVehicle>>, TError = ErrorType<VehicleUsageDto | VehicleUsageDto | VehicleUsageDto>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveUsageForVehicle>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the active vehicle usage for a single vehicle
 */

export function useGetActiveUsageForVehicle<TData = Awaited<ReturnType<typeof getActiveUsageForVehicle>>, TError = ErrorType<VehicleUsageDto | VehicleUsageDto | VehicleUsageDto>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveUsageForVehicle>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActiveUsageForVehicleQueryOptions(vehicleId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * endVehicleUsage does 2 things: 

1. Call telematics to unlock the vehicle and pass on the request to the client. Telematics which can respond in several ways: 
   - STATUS (UN)LOCKED, with mileage value. The operation was a success, the vehicle is (un)locked. In this case we update the vehicle usage and respond with status OK to the client. 
   - STATUS BLUETOOTH_<PROVIDER>_(UN)LOCKING. In this case the operation is not yet finished and the client is responsible for (un)locking the vehicle. Pass the object on to the client, which should initiate a call to update the vehicle usage later. 
   - STATUS_FAILED. The request has failed, pass the request on to the client who can try again. 

2. Call booking to update the VehicleUsage depending on the response. 

This is called when a client wants to end an active vehicleUsage for a certain booking.
 * @summary endVehicleUsage
 */
export const endVehicleUsage = (
    endVehicleUsageRequestDto: BodyType<EndVehicleUsageRequestDto>,
 ) => {
      
      
      return customInstance<VehicleUsageDto>(
      {url: `/fleet/vehicle-usage/v1/end`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: endVehicleUsageRequestDto
    },
      );
    }
  


export const getEndVehicleUsageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endVehicleUsage>>, TError,{data: BodyType<EndVehicleUsageRequestDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof endVehicleUsage>>, TError,{data: BodyType<EndVehicleUsageRequestDto>}, TContext> => {

const mutationKey = ['endVehicleUsage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof endVehicleUsage>>, {data: BodyType<EndVehicleUsageRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  endVehicleUsage(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EndVehicleUsageMutationResult = NonNullable<Awaited<ReturnType<typeof endVehicleUsage>>>
    export type EndVehicleUsageMutationBody = BodyType<EndVehicleUsageRequestDto>
    export type EndVehicleUsageMutationError = ErrorType<unknown>

    /**
 * @summary endVehicleUsage
 */
export const useEndVehicleUsage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endVehicleUsage>>, TError,{data: BodyType<EndVehicleUsageRequestDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof endVehicleUsage>>,
        TError,
        {data: BodyType<EndVehicleUsageRequestDto>},
        TContext
      > => {

      const mutationOptions = getEndVehicleUsageMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Ends the active *private* vehicle usage on the given vehicle (a usage with no booking, e.g. owner-driven). Fails if the active usage is associated with a booking — use endVehicleUsage in that case.
 * @summary endPrivateVehicleUsage
 */
export const endPrivateVehicleUsage = (
    endPrivateVehicleUsageRequestDto: BodyType<EndPrivateVehicleUsageRequestDto>,
 ) => {
      
      
      return customInstance<VehicleUsageDto>(
      {url: `/fleet/vehicle-usage/v1/end-private-usage`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: endPrivateVehicleUsageRequestDto
    },
      );
    }
  


export const getEndPrivateVehicleUsageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endPrivateVehicleUsage>>, TError,{data: BodyType<EndPrivateVehicleUsageRequestDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof endPrivateVehicleUsage>>, TError,{data: BodyType<EndPrivateVehicleUsageRequestDto>}, TContext> => {

const mutationKey = ['endPrivateVehicleUsage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof endPrivateVehicleUsage>>, {data: BodyType<EndPrivateVehicleUsageRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  endPrivateVehicleUsage(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EndPrivateVehicleUsageMutationResult = NonNullable<Awaited<ReturnType<typeof endPrivateVehicleUsage>>>
    export type EndPrivateVehicleUsageMutationBody = BodyType<EndPrivateVehicleUsageRequestDto>
    export type EndPrivateVehicleUsageMutationError = ErrorType<unknown>

    /**
 * @summary endPrivateVehicleUsage
 */
export const useEndPrivateVehicleUsage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endPrivateVehicleUsage>>, TError,{data: BodyType<EndPrivateVehicleUsageRequestDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof endPrivateVehicleUsage>>,
        TError,
        {data: BodyType<EndPrivateVehicleUsageRequestDto>},
        TContext
      > => {

      const mutationOptions = getEndPrivateVehicleUsageMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Returns every active vehicle usage (the vehicle is still physically out) whose linked booking is past its planned end, across the whole fleet. Each item carries the usage (flat), its booking, the vehicle's battery percentage and distance from home, and the adjacent events on the vehicle's timeline. batteryPercentage and distanceFromHomePosition are null when telematics data is unavailable. adjacentEvents is always present — its current event is synthesized from the booking when no matching availability event exists, while previous/next are null when availability data is unavailable. The list is always returned in full. Synthetic private-use bookings are included.
 * @summary Get overdue vehicle usages
 */
export const getOverdueVehicleUsages = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<OverdueVehicleUsageDto[]>(
      {url: `/fleet/vehicle-usage/v1/overdue`, method: 'GET', signal
    },
      );
    }
  

export const getGetOverdueVehicleUsagesQueryKey = () => {
    return [`/fleet/vehicle-usage/v1/overdue`] as const;
    }

    
export const getGetOverdueVehicleUsagesQueryOptions = <TData = Awaited<ReturnType<typeof getOverdueVehicleUsages>>, TError = ErrorType<OverdueVehicleUsageDto[] | OverdueVehicleUsageDto[] | OverdueVehicleUsageDto[]>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverdueVehicleUsages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOverdueVehicleUsagesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOverdueVehicleUsages>>> = ({ signal }) => getOverdueVehicleUsages(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOverdueVehicleUsages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOverdueVehicleUsagesQueryResult = NonNullable<Awaited<ReturnType<typeof getOverdueVehicleUsages>>>
export type GetOverdueVehicleUsagesQueryError = ErrorType<OverdueVehicleUsageDto[] | OverdueVehicleUsageDto[] | OverdueVehicleUsageDto[]>


export function useGetOverdueVehicleUsages<TData = Awaited<ReturnType<typeof getOverdueVehicleUsages>>, TError = ErrorType<OverdueVehicleUsageDto[] | OverdueVehicleUsageDto[] | OverdueVehicleUsageDto[]>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverdueVehicleUsages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOverdueVehicleUsages>>,
          TError,
          Awaited<ReturnType<typeof getOverdueVehicleUsages>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverdueVehicleUsages<TData = Awaited<ReturnType<typeof getOverdueVehicleUsages>>, TError = ErrorType<OverdueVehicleUsageDto[] | OverdueVehicleUsageDto[] | OverdueVehicleUsageDto[]>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverdueVehicleUsages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOverdueVehicleUsages>>,
          TError,
          Awaited<ReturnType<typeof getOverdueVehicleUsages>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOverdueVehicleUsages<TData = Awaited<ReturnType<typeof getOverdueVehicleUsages>>, TError = ErrorType<OverdueVehicleUsageDto[] | OverdueVehicleUsageDto[] | OverdueVehicleUsageDto[]>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverdueVehicleUsages>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get overdue vehicle usages
 */

export function useGetOverdueVehicleUsages<TData = Awaited<ReturnType<typeof getOverdueVehicleUsages>>, TError = ErrorType<OverdueVehicleUsageDto[] | OverdueVehicleUsageDto[] | OverdueVehicleUsageDto[]>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverdueVehicleUsages>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOverdueVehicleUsagesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * startVehicleUsage does 2 things: 

1. Call booking to create and persist a VehicleUsage (which should be in a pending state, without mileage) 

2. Call telematics to unlock the vehicle and pass on the request to the client. Telematics which can respond in several ways: 
   - STATUS (UN)LOCKED, with mileage value. The operation was a success, the vehicle is (un)locked. In this case we update the vehicle usage and respond with status OK to the client. 
   - STATUS BLUETOOTH_<PROVIDER>_(UN)LOCKING. In this case the operation is not yet finished and the client is responsible for (un)locking the vehicle. Pass the object on to the client, which should initiate a call to update the vehicle usage later. 
   - STATUS_FAILED. The request has failed, pass the request on to the client who can try again. 

This is called when a client wants to start an active vehicleUsage for a certain booking.
 * @summary startVehicleUsage
 */
export const startVehicleUsage = (
    startVehicleUsageRequestDto: BodyType<StartVehicleUsageRequestDto>,
 ) => {
      
      
      return customInstance<VehicleUsageDto>(
      {url: `/fleet/vehicle-usage/v1/start`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: startVehicleUsageRequestDto
    },
      );
    }
  


export const getStartVehicleUsageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startVehicleUsage>>, TError,{data: BodyType<StartVehicleUsageRequestDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof startVehicleUsage>>, TError,{data: BodyType<StartVehicleUsageRequestDto>}, TContext> => {

const mutationKey = ['startVehicleUsage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startVehicleUsage>>, {data: BodyType<StartVehicleUsageRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  startVehicleUsage(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StartVehicleUsageMutationResult = NonNullable<Awaited<ReturnType<typeof startVehicleUsage>>>
    export type StartVehicleUsageMutationBody = BodyType<StartVehicleUsageRequestDto>
    export type StartVehicleUsageMutationError = ErrorType<unknown>

    /**
 * @summary startVehicleUsage
 */
export const useStartVehicleUsage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startVehicleUsage>>, TError,{data: BodyType<StartVehicleUsageRequestDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startVehicleUsage>>,
        TError,
        {data: BodyType<StartVehicleUsageRequestDto>},
        TContext
      > => {

      const mutationOptions = getStartVehicleUsageMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Returns one page of all vehicle usages (the complete history — both booking-linked and private/owner-driven) for the given vehicle, ordered most-recent-first (startTime descending). Backs the fleet 'Vehicle usages' tab's infinite-scroll list. Each item is enriched with full reference objects: a vehicle reference (name, license plate, images, model), a user reference (the driver), and — for booking-linked usages — a booking reference (user, client, vehicle, status, periods); for a private usage that reference describes its system-generated mirror booking (bookingType SYNTHETIC). Server-side filters narrow the result: 'from'/'to' bound the usage startTime, 'bookingTypes' keeps usages whose linked booking has one of the given types, 'privateUsage' is tri-state (true = only bookingless usages, false = only booking-linked, omitted = both), and 'userRemoteId' keeps usages driven by that user. Filters compose with AND. 'totalElements' is the full filtered count across all pages; 'size' is capped at 100.
 * @summary Get the paged usage history of a single vehicle
 */
export const getVehicleUsagesForVehicle = (
    vehicleId: string,
    params?: GetVehicleUsagesForVehicleParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<VehicleUsagePageDto>(
      {url: `/fleet/vehicle-usage/v1/vehicle/${vehicleId}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetVehicleUsagesForVehicleQueryKey = (vehicleId?: string,
    params?: GetVehicleUsagesForVehicleParams,) => {
    return [`/fleet/vehicle-usage/v1/vehicle/${vehicleId}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetVehicleUsagesForVehicleQueryOptions = <TData = Awaited<ReturnType<typeof getVehicleUsagesForVehicle>>, TError = ErrorType<VehicleUsagePageDto | VehicleUsagePageDto | VehicleUsagePageDto>>(vehicleId: string,
    params?: GetVehicleUsagesForVehicleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleUsagesForVehicle>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVehicleUsagesForVehicleQueryKey(vehicleId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVehicleUsagesForVehicle>>> = ({ signal }) => getVehicleUsagesForVehicle(vehicleId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(vehicleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVehicleUsagesForVehicle>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVehicleUsagesForVehicleQueryResult = NonNullable<Awaited<ReturnType<typeof getVehicleUsagesForVehicle>>>
export type GetVehicleUsagesForVehicleQueryError = ErrorType<VehicleUsagePageDto | VehicleUsagePageDto | VehicleUsagePageDto>


export function useGetVehicleUsagesForVehicle<TData = Awaited<ReturnType<typeof getVehicleUsagesForVehicle>>, TError = ErrorType<VehicleUsagePageDto | VehicleUsagePageDto | VehicleUsagePageDto>>(
 vehicleId: string,
    params: undefined |  GetVehicleUsagesForVehicleParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleUsagesForVehicle>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicleUsagesForVehicle>>,
          TError,
          Awaited<ReturnType<typeof getVehicleUsagesForVehicle>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicleUsagesForVehicle<TData = Awaited<ReturnType<typeof getVehicleUsagesForVehicle>>, TError = ErrorType<VehicleUsagePageDto | VehicleUsagePageDto | VehicleUsagePageDto>>(
 vehicleId: string,
    params?: GetVehicleUsagesForVehicleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleUsagesForVehicle>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicleUsagesForVehicle>>,
          TError,
          Awaited<ReturnType<typeof getVehicleUsagesForVehicle>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicleUsagesForVehicle<TData = Awaited<ReturnType<typeof getVehicleUsagesForVehicle>>, TError = ErrorType<VehicleUsagePageDto | VehicleUsagePageDto | VehicleUsagePageDto>>(
 vehicleId: string,
    params?: GetVehicleUsagesForVehicleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleUsagesForVehicle>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the paged usage history of a single vehicle
 */

export function useGetVehicleUsagesForVehicle<TData = Awaited<ReturnType<typeof getVehicleUsagesForVehicle>>, TError = ErrorType<VehicleUsagePageDto | VehicleUsagePageDto | VehicleUsagePageDto>>(
 vehicleId: string,
    params?: GetVehicleUsagesForVehicleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleUsagesForVehicle>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVehicleUsagesForVehicleQueryOptions(vehicleId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



